import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useComponentSize, useMutableRef } from '@carnica/utils/hooks';
import { useCallback, useEffect, useState } from 'react';
export var useHiddenElementsCount = function useHiddenElementsCount(_ref) {
  var wrapperRef = _ref.wrapperRef,
    tabWidths = _ref.tabWidths;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    hiddenCount = _useState2[0],
    setHiddenCount = _useState2[1];
  var widthsRef = useMutableRef(tabWidths);
  var _useComponentSize = useComponentSize(wrapperRef),
    width = _useComponentSize.width;
  var checkHiddenCount = useCallback(function () {
    var _ref2 = wrapperRef.current || {},
      _ref2$offsetWidth = _ref2.offsetWidth,
      offsetWidth = _ref2$offsetWidth === void 0 ? 0 : _ref2$offsetWidth,
      _ref2$scrollLeft = _ref2.scrollLeft,
      scrollLeft = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft;
    var stopper = offsetWidth + scrollLeft;
    var targetWidth = 0;
    var firstHiddenIndex = widthsRef.current.findIndex(function (el) {
      if (targetWidth + el < stopper) {
        targetWidth += el;
        return false;
      }
      return true;
    });
    setHiddenCount(firstHiddenIndex >= 0 ? widthsRef.current.length - firstHiddenIndex : -1);
  }, []);
  useEffect(function () {
    var _wrapperRef$current;
    (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.addEventListener('scroll', checkHiddenCount);
    setTimeout(checkHiddenCount, 300);
    return function () {
      var _wrapperRef$current2;
      (_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.removeEventListener('scroll', checkHiddenCount);
    };
  }, []);
  useEffect(checkHiddenCount, [tabWidths, width]);
  return hiddenCount;
};